import './confirm/confirm.js';
import './modal/preview.js';
import './modal/saveModal.js';
import './export.tpl.html';
import './selectDestinationView/selectDestinationView.js';
import './selectView/selectview.js';
import './settings/settings.js';
import './uploadView/uploadView.js';
import './verifiedCsvSelectView/verifiedcsvselectview.js';

angular
  .module('bulkExport', [
    'ui.router',
    'ngAnimate',
    'bulkExport.confirm',
    'bulkExport.preview',
    'bulkExport.selectview',
    'bulkExport.selectDestinationView',
    'bulkExport.settings',
    'bulkExport.uploadView',
    'bulkExport.verifiedCsvSelectView',
    'sbsf.constants',
    'services.bulkrestoredata',
    'services.error',
    'services.view',
    'shared.confirmModal'
  ])
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      // These params are shared between multiple states
      var bulkRestoreParams = {
        // This will be set if we've already entered the flow
        bulkRestoreData: {
          value: null,
          squash: true
        },
        // This will be set if we're coming in from a link in an email
        page: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from a link in an email
        batchId: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        bulkRestoreType: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log
        batch: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log for a backup
        objectStates: {
          value: null,
          squash: true
        },
        // This will be set if we're coming from the activity log for a backup
        objectType: {
          value: null,
          squash: true
        }
      };

      // This view is shared between multiple states
      let csvVerificationProgress = {
        templateUrl: 'bulkRestore/csvVerificationProgress.tpl.html',
        controller: 'SharedProgressCtrl'
      };

      // This defines the main abstract bulk export view that is shared across all subviews.
      $stateProvider
        .state(VIEW_STATES.BULK_EXPORT, {
          abstract: true,
          views: {
            content: {
              templateUrl: 'bulkExport/export.tpl.html',
              controller: 'BulkExportCtrl'
            }
          },
          resolve: {
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          }
        })
        .state(VIEW_STATES.BULK_EXPORT_ENTER, {
          url: '/bulkExport/enter',
          params: bulkRestoreParams
        })
        // The views that are rendered in the object select view.
        .state(VIEW_STATES.BULK_EXPORT_SELECT_OBJECT, {
          url: '/bulkExport/selectview',
          params: bulkRestoreParams,
          resolve: {
            objectTypes: [
              'BulkRestoreService',
              function (BulkRestoreService) {
                return BulkRestoreService.getObjectTypes(true, { filterNonRestorableTypes: false });
              }
            ]
          },
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/selectView/selectview.tpl.html',
              controller: 'BulkExportSelectViewCtrl'
            }
          }
        })
        // The views that are rendered in the CSV upload view.
        .state(VIEW_STATES.BULK_EXPORT_UPLOAD_CSV, {
          url: '/bulkExport/uploadView',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/uploadView/uploadView.tpl.html',
              controller: 'BulkExportUploadViewCtrl'
            }
          }
        })
        // The views that are rendered in the select view after a CSV verification.
        .state(VIEW_STATES.BULK_EXPORT_SELECT_CSV, {
          url: '/bulkExport/verifiedcsvselectview',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/verifiedCsvSelectView/verifiedcsvselectview.tpl.html',
              controller: 'BulkExportVerifiedCsvSelectViewCtrl'
            }
          }
        })
        // The views that are rendered in the export destination view.
        .state(VIEW_STATES.BULK_EXPORT_SELECT_DEST, {
          url: '/bulkExport/selectDestinationView',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/selectDestinationView/selectDestinationView.tpl.html',
              controller: 'BulkExportSelectDestinationViewCtrl'
            }
          }
        })
        // The views that are rendered in the settings view.
        .state(VIEW_STATES.BULK_EXPORT_SETTINGS, {
          url: '/bulkExport/settings',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/settings/settings.tpl.html',
              controller: 'BulkExportSettingsCtrl'
            },
            csvVerificationProgress: csvVerificationProgress
          }
        })
        // The views that are rendered in the confirm view.
        .state(VIEW_STATES.BULK_EXPORT_CONFIRM_OBJECT, {
          url: '/bulkExport/confirm',
          params: bulkRestoreParams,
          views: {
            wizardContent: {
              templateUrl: 'bulkExport/confirm/confirm.tpl.html',
              controller: 'ExportConfirmCtrl'
            }
          }
        });
    }
  ])
  /**
   * Controller for the bulk export view.
   */
  .controller('BulkExportCtrl', [
    '$q',
    '$scope',
    '$state',
    '$rootScope',
    'WizardService',
    'BulkRestoreDataFactory',
    'BulkRestoreService',
    'BulkRestoreType',
    'ErrorService',
    'progressFactory',
    'httpBatch',
    'batchUtils',
    'viewUtils',
    'orgInfo',
    'VIEW_STATES',
    'BULK_RESTORE_TYPES',
    'BULK_RESTORE_DEST_TYPES',
    'ALERT_EVENTS',
    'SOBJECT_STATE',
    function (
      $q,
      $scope,
      $state,
      $rootScope,
      WizardService,
      BulkRestoreDataFactory,
      BulkRestoreService,
      BulkRestoreType,
      ErrorService,
      progressFactory,
      httpBatch,
      batchUtils,
      viewUtils,
      orgInfo,
      VIEW_STATES,
      BULK_RESTORE_TYPES,
      BULK_RESTORE_DEST_TYPES,
      ALERT_EVENTS,
      SOBJECT_STATE
    ) {
      // Publish some functions for testing
      $scope.initBulkRestoreDataForVerifiedCsv = initBulkRestoreDataForVerifiedCsv;

      initBulkRestoreData()
        .then(function (bulkRestoreData) {
          $scope.bulkRestoreData = bulkRestoreData;

          watchForDestroy();
          watchCsvVerification();
          goToInitialState();
        })
        .finally(function () {
          // initBulkRestoreData may have shown the loading mask if it needed to load a batch
          $rootScope.showLoadingMask = false;
        });

      /**
       * Initializes the bulk export data if it was not passed in.
       *
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreData() {
        var bulkRestoreData = $state.params.bulkRestoreData;
        var promise;

        if (bulkRestoreData) {
          promise = $q.when(bulkRestoreData);
        } else {
          // The page param will be set if we're getting here from a link in an email.
          // The bulkRestoreType will be set if we're getting here from the activity log.
          if (
            $state.params.page === 'bulkExportCsv' ||
            $state.params.bulkRestoreType === BulkRestoreType.VERIFIED_CSV
          ) {
            // We have to load the batch in order to initialize the bulk restore data
            promise = initBulkRestoreDataForVerifiedCsv($state.params);
          } else if ($state.params.bulkRestoreType === BulkRestoreType.BACKUP) {
            promise = initBulkRestoreDataForBackup($state.params);
          } else {
            // Create the default data
            bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.MANUAL, { sourceOrgInfo: orgInfo });
            promise = $q.when(bulkRestoreData);
          }
        }

        return promise;
      }

      /**
       * Initializes the bulk restore data for a verified CSV.
       *
       * @param {{[batchId]: number, [batch]: object}} params - the CSV verification params.
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreDataForVerifiedCsv(params) {
        // See if the batch is already present
        var promise;
        if (params.batch) {
          promise = $q.when(params.batch);
        } else if (params.batchId) {
          $rootScope.showLoadingMask = true;
          promise = batchUtils.loadBatch(params.batchId);
        } else {
          throw new Error('batch or batchId is required');
        }

        return promise.then(function (batch) {
          var csvData = batch.bulkRestoreCsvVerificationData;
          var destType =
            csvData.sourceOrgId === csvData.targetOrgId
              ? BULK_RESTORE_DEST_TYPES.SAME_ORG
              : BULK_RESTORE_DEST_TYPES.CROSS_ORG;
          var destOrgInfo = {
            id: csvData.targetOrgId,
            name: csvData.targetOrgName
          };
          var isFailure = batch.status === 'FAILURE';
          var csvFailureMsg;

          // If it's a failure we need the events
          if (isFailure && !batch.events) {
            promise = batchUtils.getBatchEvents(batch.batchId);
          } else {
            promise = $q.when(batch.events);
          }

          return promise
            .then(function (events) {
              csvFailureMsg = isFailure ? events[0].message : '';

              // If the object type is not specified that means there's more than one type and we have to get the types
              // from the server.
              if (csvData.sobjectType) {
                promise = $q.when([csvData.sobjectType]);
              } else {
                promise = BulkRestoreService.getCsvObjectTypes(batch.batchId);
              }

              return promise;
            })
            .then(function (csvObjectTypes) {
              var bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.VERIFIED_CSV, {
                backupBatchDate: csvData.batchIdToVerifyDate,
                backupBatchId: csvData.batchIdToVerify,
                csvBatchId: batch.batchId,
                csvCompletedBulkRestoreBatch: _.first(csvData.completedBulkRestoreBatches),
                csvDuplicateCount: batch.duplicateObjects,
                csvFailed: isFailure,
                csvFailureMsg: csvFailureMsg,
                csvFileName: csvData.fileName,
                csvInvalidCount: batch.invalidObjects,
                csvObjectTypes: csvObjectTypes,
                destOrgInfo: destOrgInfo,
                destType: destType,
                searchObjectStates: [SOBJECT_STATE.UPDATED],
                sourceOrgInfo: orgInfo
              });

              // Start with all records selected for a verified CSV restore
              bulkRestoreData.setSelectingAll(true);

              return bulkRestoreData;
            });
        });
      }

      /**
       * Initializes the bulk restore data for restoring from a backup.
       *
       * @param {{batch: object, objectStates: number[], objectType: string}} params - the backup params.
       * @returns {Promise} a promise that resolves when the data has been initialized.
       */
      function initBulkRestoreDataForBackup(params) {
        if (!params.batch) {
          throw new Error('batch is required');
        }

        if (!params.objectStates) {
          throw new Error('objectStates is required');
        }

        if (!params.objectType) {
          throw new Error('objectType is required');
        }

        var bulkRestoreData = BulkRestoreDataFactory.generate(BulkRestoreType.BACKUP, {
          backupBatchId: params.batch.batchId,
          backupBatchDate: params.batch.date,
          searchObjectStates: [params.objectStates],
          searchObjectType: params.objectType,
          sourceOrgInfo: orgInfo
        });

        // Start with all records selected for a restore from backup
        bulkRestoreData.setSelectingAll(true);

        return $q.when(bulkRestoreData);
      }

      /**
       * Watches for the scope to be destroyed in order to do some clean-up.
       */
      function watchForDestroy() {
        $scope.$on('$destroy', function () {
          viewUtils.resetKey('export');
          $rootScope.$emit(ALERT_EVENTS.CLOSE.eventName);
        });
      }

      /**
       * Watches for progress on a CSV verification and updates the restore flow when it completes.
       */
      function watchCsvVerification() {
        // When the user initiates a CSV verification we'll give them the option to stay on this page and wait or go to
        // the dashboard. If there is already a CSV verification running we'll show this mask from the start.
        $rootScope.showMaskWithDashboardButton = progressFactory.bulkRestoreCsvVerificationInProgress;

        // When we start a CSV verification we show a mask on the screen. Watch for the verification to finish so we can
        // remove the mask.
        $scope.$watch(
          function () {
            return progressFactory.bulkRestoreCsvVerificationInProgress;
          },
          function (newValue, oldValue) {
            if (oldValue === true && newValue === false) {
              httpBatch
                .getLatestBulkRestoreCsvVerification()
                .then(function (batch) {
                  return $scope.initBulkRestoreDataForVerifiedCsv({ batch: batch });
                })
                .then(function (bulkRestoreData) {
                  // Get the wizard set up for the new state
                  initWizard(VIEW_STATES.BULK_EXPORT_SELECT_CSV);
                  $state.go(VIEW_STATES.BULK_EXPORT_SELECT_CSV, { bulkRestoreData: bulkRestoreData });
                })
                .catch(function (err) {
                  ErrorService.report(err);
                })
                .finally(function () {
                  $rootScope.showLoadingMask = false;
                  $rootScope.showMaskWithDashboardButton = false;
                });
            } else if (oldValue === false && newValue === true) {
              // Show the dashboard mask when a verification starts
              $rootScope.showMaskWithDashboardButton = true;
            }
          }
        );
      }

      /**
       * Determines the initial state of the wizard from the data source.
       */
      function goToInitialState() {
        var state = VIEW_STATES.BULK_EXPORT_SELECT_DEST;

        switch ($scope.bulkRestoreData.getRestoreType()) {
          case BulkRestoreType.BACKUP:
            state = VIEW_STATES.BULK_EXPORT_SELECT_OBJECT;
            break;

          case BulkRestoreType.VERIFIED_CSV:
            state = VIEW_STATES.BULK_EXPORT_SELECT_CSV;
            break;

          case BulkRestoreType.MANUAL:
          default:
            break;
        }

        initWizard(state);
        $state.go(state, { bulkRestoreData: $scope.bulkRestoreData });
      }

      /**
       * Sets up the wizard service to track the flow through this wizard.
       *
       * @param {string} [initialState] - The start in which to start the wizard.
       */
      function initWizard(initialState) {
        var stepKeys;

        // Reset the WizardService so we start fresh each time
        WizardService.reset();

        // Determine the initial state if it's not supplied
        if (!initialState) {
          if (
            $state.current.name === VIEW_STATES.BULK_EXPORT_SELECT_OBJECT ||
            $state.current.name === VIEW_STATES.BULK_EXPORT_SELECT_CSV
          ) {
            initialState = $state.current.name;
          } else {
            initialState = VIEW_STATES.BULK_EXPORT_SELECT_DEST;
          }
        }

        // The potential steps depend on the initial state
        switch (initialState) {
          case VIEW_STATES.BULK_EXPORT_SELECT_DEST:
            // Type has not been selected
            // null in the last position means we don't yet know the remaining steps
            stepKeys = ['SELECT_METHOD', null];
            break;

          case VIEW_STATES.BULK_EXPORT_SELECT_CSV:
          case VIEW_STATES.BULK_EXPORT_SELECT_OBJECT:
            // We started from a specific record type in a backup or from a verified CSV
            stepKeys = ['SELECT_ITEMS', 'EXPORT_SETTINGS', 'CONFIRM_EXPORT'];
            break;

          default:
            break;
        }

        // Initialize the wizard
        WizardService.setStatePrefix(VIEW_STATES.BULK_EXPORT + '.');
        WizardService.setNextState(getNextState);
        WizardService.setInitialState(initialState);
        WizardService.setStepKeys(stepKeys);
        WizardService.setCancelConfirmTextKey('CONFIRM_EXPORT_EXIT');
      }

      /**
       * Determines the state that comes after the current state, based on the current settings.
       *
       * @returns {string} the name of the state corresponding to the next page.
       */
      function getNextState() {
        var currentState = WizardService.getCurrentState();
        var nextState;

        switch (currentState) {
          case VIEW_STATES.BULK_EXPORT_SELECT_DEST:
            if ($scope.bulkRestoreData.isManualObjectUpload()) {
              nextState = VIEW_STATES.BULK_EXPORT_UPLOAD_CSV;
            } else {
              nextState = VIEW_STATES.BULK_EXPORT_SELECT_OBJECT;
            }
            break;

          case VIEW_STATES.BULK_EXPORT_SELECT_OBJECT:
          case VIEW_STATES.BULK_EXPORT_SELECT_CSV:
            nextState = VIEW_STATES.BULK_EXPORT_SETTINGS;
            break;

          case VIEW_STATES.BULK_EXPORT_SETTINGS:
            nextState = VIEW_STATES.BULK_EXPORT_CONFIRM_OBJECT;
            break;

          default:
            break;
        }

        return nextState;
      }
    }
  ]);
